import {makeAutoObservable} from "mobx";

export default class ProductStore {
    constructor() {
        this._types = []
        this._genders = []
        this._products = []
        this._selectedType = {}
        this._selectedGender = {}
        this._page = 1
        this._totalCount = 0
        this._limit = 3
        this._sortBy = 'rating' // 'rating' or 'price'
        this._sortOrder = 'desc' // 'asc' or 'desc'
        makeAutoObservable(this)
    }

    setTypes(types) {
        this._types = types
    }
    setGenders(genders) {
        this._genders = genders
    }
    setProducts(products) {
        this._products = products
    }
    setSelectedType(type) {
        this.setPage(1)
        this._selectedType = type
    }
    setSelectedGender(gender) {
        this.setPage(1)
        this._selectedGender = gender
    }
    setPage(page) {
        this._page = page
    }
    setTotalCount(count) {
        this._totalCount = count
    }
    setSortBy(sortBy) {
        this._sortBy = sortBy
    }
    setSortOrder(sortOrder) {
        this._sortOrder = sortOrder
    }

    get types() {
        return this._types
    }
    get genders() {
        return this._genders
    }
    get products() {
        return this._products
    }
    get selectedType() {
        return this._selectedType
    }
    get selectedGender() {
        return this._selectedGender
    }
    get totalCount() {
        return this._totalCount
    }
    get page() {
        return this._page
    }
    get limit() {
        return this._limit
    }
    get sortBy() {
        return this._sortBy
    }
    get sortOrder() {
        return this._sortOrder
    }

    updateProductInStore(updatedProduct) {
        const idx = this._products.findIndex(p => p.id === updatedProduct.id);
        if (idx !== -1) {
            this._products[idx] = { ...this._products[idx], ...updatedProduct };
        }
    }
}